<template>
  <div class="customers-list container-fluid">

    <div class="row">
      <div class="col-md-6 col-lg-3">

        <b-btn v-if="this.getWeb2ActiveAccount && this.getWeb2ActiveAccount.role.name === 'Administrator'"
               id="customer-add-btn" class="mr-2" @click="$router.push('/customers/new')">
          <b-icon-plus></b-icon-plus>
          Add new
        </b-btn>
      </div>
      <div class="col-md-6 col-lg-3 offset-lg-6">
        <b-form-input
          id="customer-search-input"
          v-model="searchTable"
          placeholder="Search"
          required

          type="text"
          @keyup="onKeyUp()"
        ></b-form-input>
      </div>
    </div>
    <PlantLoader v-if="loading" text="Growing your customer list…" />
    <table id="customers-datatables" v-show="!loading" class="table table-striped table-bordered mb-3" style="width:100%;">
    </table>
  </div>
</template>

<script>
import "datatables.net/js/jquery.dataTables";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-fixedheader-bs4/js/fixedHeader.bootstrap4";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4";
import "datatables.net-scroller-bs4/js/scroller.bootstrap4";

import Customer from "../../api/Customer"
import {mapActions, mapGetters} from "vuex";
// import moment from 'moment';
// import Config from "../../api/Config";
// import Stats from '../../api/Stats'
import $ from 'jquery'
import Swal from "sweetalert2";
import Header from "@/utils/Header";
import TokenStorage from "@/utils/TokenStorage";
import copy from "copy-to-clipboard";
import createPageTourMixin from "../../mixins/pageTour";
import PlantLoader from "../PlantLoader.vue";
// import Header from '../utils/Header'
// import TokenStorage from '../utils/TokenStorage'

const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

const tourSteps = [
  {
    element: "#customer-add-btn",
    popover: {
      title: "Add a customer",
      description: "Register a new customer account by hand — name, email and wallet address."
    }
  },
  {
    element: "#customer-search-input",
    popover: {
      title: "Search",
      description: "Filter the list by name, email or wallet address as you type."
    }
  },
  {
    element: "#customers-datatables",
    popover: {
      title: "Customers",
      description: "Each row is a customer. Open its <strong>Actions</strong> menu to view their profile, issue a certificate, send a password reset, or delete the account."
    }
  }
];

export default {
  name: 'CustomersList',

  mixins: [createPageTourMixin('customers', tourSteps)],

  components: { PlantLoader },

  data() {
    return {
      customers: null,
      userId: null,
      config: null,
      stats: {},
      customersTable: null,
      searchTable: null,
      loading: true,
    }
  },
  computed: {
    ...mapGetters("user", ["getWeb2ActiveAccount"]),
  },
  beforeDestroy() {
    // the handlers live on document: left behind, they pile up on every visit
    // (two toggles = the menu opens and closes again, Actions "does nothing")
    $(document).off('.customersList');
    if (this.customersTable) this.customersTable.destroy();
  },
  async mounted() {
    // this.config = (await Config.getConfig()).data;
    // Stats.getStats()
    //     .then((stats) => {
    // let global = this;
    if (this.getWeb2ActiveAccount && this.getWeb2ActiveAccount.role.name === 'Authenticated') {
      this.userId = this.getWeb2ActiveAccount.id;
    }


    this.customersTable = $('#customers-datatables').DataTable({
      processing: true,
      serverSide: true,
      stateSave: true,
      initComplete: () => {
        this.loading = false
      },
      dom: 'rt<"row mt-2"<"d-none d-md-block col-md-6"l><"col-md-6"p>>',
      lengthMenu: [[14, 25, 50, 100, 200, 10000000000000], [14, 25, 50, 100, 200, "All"]],
      order: [0, 'desc'],
      // fixedHeader: true,
      // responsive: true,
      // dom: 't',
      // scrollY: 'calc(100vh - 210px)',
      // scroller: {
      //   loadingIndicator: true,
      //   displayBuffer: 2
      // },
      // order: [[0, 'desc']],
      ajax: {
        url: process.env.VUE_APP_API_URL + '/customers-datatables',
        type: 'POST',
        headers: {
          "Authorization": Header.getTokenValue(TokenStorage.get())
        },
      },
      columns: [
        {
          width: 40,
          title: 'ID',
          data: 'id',
          defaultContent: '',
        },
        {
          title: 'Name',
          data: 'name',
          defaultContent: ''
        },
        {
          title: 'Type',
          data: 'userType',
          defaultContent: ''
        },
        {
          title: 'Company',
          data: 'companyName',
          defaultContent: ''
        },
        {
          title: 'Email',
          data: 'email',
          defaultContent: ''
        },
        {
          title: 'Wallet Address',
          data: 'WalletAddress',
          defaultContent: ''
        },
        {
          title: 'Actions',
          data: 'id',
          defaultContent: ''
        }
      ],
      columnDefs: [
        {
          targets: 0,
          responsivePriority: 0,
        },
        {
          // Owner and Partner: users of a partner company (they use the panel); Customer: everybody else
          targets: 2,
          render: (type, kind, row) => {
            if (kind !== 'display') return type;
            const chips = type === 'owner'
              ? '<span class="user-type partner">Partner</span><span class="user-type owner">Owner</span>'
              : type === 'partner' ? '<span class="user-type partner">Partner</span>' : '<span class="user-type customer">Customer</span>';
            return chips + (Number(row.blocked) ? '<span class="user-type blocked">Blocked</span>' : '');
          },
        },
        {
          targets: 3,
          render: (name, kind, row) => {
            if (kind !== 'display') return name || '';
            if (!name) return '<span class="no-company">—</span>';
            return `<a href="/companies/${Number(row.companyId)}" class="company-link"><i class="fas fa-building"></i> ${escapeHtml(name)}</a>`;
          },
        },
        {
          // shortened so the table fits the window (the full address pushed Actions
          // past the right edge); the full one is in the tooltip and the copy button
          targets: 5,
          render: (wallet, kind) => {
            if (kind !== 'display') return wallet || '';
            if (!wallet) return '';
            const short = wallet.length > 12 ? `${wallet.slice(0, 6)}…${wallet.slice(-4)}` : wallet;
            return `<span class="wallet"><span class="wallet-short" title="${escapeHtml(wallet)}">${escapeHtml(short)}</span>`
              + `<button type="button" class="wallet-copy" data-wallet="${escapeHtml(wallet)}" title="Copy address"><i class="far fa-copy"></i></button></span>`;
          },
        },
        {
          targets: 6,
          responsivePriority: 0,
          data: 'id',
          // visible: false,
          render: (id, type) => {


            if (type === 'display') {
              return `
              <div class="dropdown">
            <button type="button" class="btn btn-sm row-actions-btn dropdown-toggle customer-actions-toggle" data-id="${id}">
              Actions
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <a href="/customers/${id}" class="dropdown-item">View</a>
              <a data-id="${id}" class="dropdown-item del-customer-btn">Delete</a>
              <a data-id="${id}" class="dropdown-item cert-customer-btn">Certificate</a>
              <a data-id="${id}" class="dropdown-item send-customer-btn">Send password</a>
            </div>
          </div>
              `;

            } else {

              return ``;

            }
          },
        }
      ]
    });

    // Bootstrap's dropdown CSS is loaded (via app.scss's bootstrap.scss
    // import) but its JS plugin isn't, and these action menus are rendered
    // as raw HTML by DataTables — so the open/close toggle is done by hand
    // here instead of relying on bootstrap.js or a bootstrap-vue component.
    // All of them under the .customersList namespace, removed in beforeDestroy.
    $(document).off('.customersList');
    $(document).on('click.customersList', '.customer-actions-toggle', function (e) {
      e.stopPropagation();
      const menu = $(this).next('.dropdown-menu');
      const wasOpen = menu.hasClass('show');
      $('.dropdown-menu').removeClass('show');
      // Elevate the whole row, not just the .dropdown wrapper — the thing
      // that visually overlaps the open menu is the NEXT ROW's Actions
      // button, so the stacking context has to be raised at the <tr> level
      // for the z-index to actually win against it.
      $('tr.dropdown-elevated').removeClass('dropdown-elevated');
      if (!wasOpen) {
        menu.addClass('show');
        $(this).closest('tr').addClass('dropdown-elevated');
      }
    });
    $(document).on('click.customersList', function () {
      $('.dropdown-menu').removeClass('show');
      $('tr.dropdown-elevated').removeClass('dropdown-elevated');
    });

    let global = this;
    // the company link opens the company inside the app (no page reload)
    $(document).on('click.customersList', '.customers-list .company-link', function (e) {
      e.preventDefault();
      global.$router.push($(this).attr('href')).catch(() => {});
    });
    $(document).on('click.customersList', '.customers-list .wallet-copy', function () {
      copy($(this).attr('data-wallet'));
      const icon = $(this).find('i').attr('class', 'fas fa-check');
      setTimeout(() => icon.attr('class', 'far fa-copy'), 1500);
    });
    $(document).on('click.customersList', '.del-customer-btn', function () {
      const id = $(this).data('id')
      if (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "Do you want to delete this customer?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            Customer.delCustomers(id).then(() => {
              global.customersTable.ajax.reload();
              Swal.fire(
                'Successfully deleted',
                `You've successfully delete this customer.`,
                'success');
            })
          }
        })

      }
    })


    $(document).on('click.customersList', '.send-customer-btn', function () {
      const id = $(this).data('id')
      if (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "Do you want to send an email to restore the customer password?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {

            Swal.fire(
              'Successfully send',
              `You've successfully send the email.`,
              'success');

          }
        })

      }
    })


    $(document).on('click.customersList', '.cert-customer-btn', function () {
      const id = $(this).data('id')
      if (id) {
        Swal.fire({
          title: 'Certificate',
          html: `The certificate URL is: <a href="${process.env.VUE_APP_CERT_URL}/${id}" target="_blank">${process.env.VUE_APP_CERT_URL}/${id}</a>`,
          icon: 'info',
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonColor: '#2e2e2e',
          cancelButtonText: 'Close',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Copy URL'
        }).then((result) => {
          if (result.isConfirmed) {
            copy(`${process.env.VUE_APP_CERT_URL}/${id}`)

            Swal.fire(
              'Copied!',
              `The certificate URL has been copied successfully`,
              'success');

          }
        })

      }
    })


    //     }).catch((error) => {
    //   console.log(error)
    // })
  },
  methods: {
    ...mapActions("tokenContract", ["claim"]),
    onKeyUp() {
      this.customersTable.search(this.searchTable).draw();
    },
    showMyCustomers() {
      this.userId = this.getWeb2ActiveAccount.id;
      this.customersTable.ajax.reload();
    },
    showAllCustomers() {
      this.userId = null;
      this.customersTable.ajax.reload();
    },
    loadTableClaimableStats(customerId) {
      $('#claimable-amount-' + customerId).html(`...`);
      $('#claimable-balance-' + customerId).html(`...€`);

      Customer.getClaimable(customerId).then((data) => {
        const claimable = data.data.totalCO2;
        if (parseFloat(claimable)) {
          $('#claimable-' + customerId).prop('disabled', false);
        } else {

          $('#claimable-' + customerId).prop('disabled', true);

        }

        $('#claimable-amount-' + customerId).html(new Intl.NumberFormat('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(claimable))

        $('#claimable-balance-' + customerId).html(new Intl.NumberFormat('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(claimable * 80) + '€')

      })
    },
    getCustomers() {

    }
  }
}
</script>

<style lang="scss">
/* cells rendered by DataTables (plain HTML, so not scoped) */
.customers-list {
  .user-type {
    display: inline-block;
    margin: 1px 4px 1px 0;
    padding: 2px 9px;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 800;
    white-space: nowrap;
    &.customer { color: var(--accent-green-dark); background: rgba(var(--accent-green-rgb), 0.14); }
    &.partner { color: #2f6fa8; background: rgba(95, 180, 240, 0.18); }
    &.owner { color: #8a5d10; background: rgba(244, 194, 91, 0.24); }
    &.blocked { color: #c4532f; background: rgba(224, 106, 68, 0.14); }
  }
  .company-link { font-weight: 700; color: var(--text-heading); i { color: var(--accent-green); margin-right: 3px; } &:hover { color: var(--accent-green); text-decoration: none; } }
  .no-company { color: var(--text-muted); }
  .wallet { white-space: nowrap; }
  .wallet-short { font-family: monospace; }
  .wallet-copy {
    border: 0; background: none; padding: 0 0 0 6px;
    color: var(--text-muted);
    &:hover { color: var(--accent-green); }
  }
}

// 7 columns x 48px of side padding do not fit next to the sidebar on laptop
// screens (Actions ended past the right edge); th keeps room for the sort arrows
@media (max-width: 1399.98px) {
  .customers-list #customers-datatables {
    td { padding-left: 12px; padding-right: 12px; }
    th { padding-left: 12px; }
  }
}

[data-theme="dark"] .customers-list {
  .user-type.partner { color: #8cc7f2; }
  .user-type.owner { color: #f4c25b; }
  .user-type.customer { color: var(--accent-green-light); }
}
</style>
